import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { Button } from '../Button';
import { Tooltip } from '../Tooltip';
import User from './User';
import { IUserProps } from './UserProps';

const BUTTON_WIDTH = 55;

const LayoutPaddingSmall = `
  padding: ${toRem(16.5)} ${toRem(BUTTON_WIDTH + 16.5)} ${toRem(16.5)}
    ${toRem(16.5)};
`;

const LayoutPaddingLarge = `
  padding: ${toRem(11)} ${toRem(BUTTON_WIDTH + 11)} ${toRem(11)}
    ${toRem(16.5)};
`;

const Layout = styled.li`
  position: relative;
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: auto;
  min-height: ${toRem(theme.user.item.height)};
  ${LayoutPaddingSmall};
  background-color: ${theme.color.white};
  border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};
  overflow: hidden;

  @media (min-width: ${theme.breakpoint.small}px) {
    ${LayoutPaddingLarge}
  }

  &:last-child {
    border-bottom: 0;
  }
`;

const StyledUser = styled(User)`
  flex-grow: 0;
  flex-shrink: 0;
  width: 100%;

  > section {
    width: 100%;

    p {
      width: 100%;
    }
  }
`;

const StyledButton = styled(Button)`
  width: ${toRem(BUTTON_WIDTH)};
`;

interface UserListItemProps extends IUserProps {
  onSelect?: () => void;
  className?: string;
  disabledToolTip?: string;
}

const UserListItem: React.FC<UserListItemProps> = ({ id, username, image, role, site, onSelect, hasPaymentMethod, className, disabled, disabledToolTip, ...rest }) => (
  <Layout className={className} {...rest}>
    <StyledUser id={id} username={username} hasPaymentMethod={hasPaymentMethod} image={image} role={role} site={site} wrapText data-cy="user-list-item-user" />

    <StyledButton appearance="primary" data-cy="user-list-item-add-btn" disabled={disabled} label="Add" onClick={onSelect} size="small" tooltipId={`disabledTooltip-${id}`} />
    {disabled && (
      <Tooltip id={`disabledTooltip-${id}`} place="left">
        {disabledToolTip}
      </Tooltip>
    )}
  </Layout>
);

export default UserListItem;
